import { buildSpValueToString } from 'utils/snowplow/utils/buildSpValueToString'

const DOB_CHILD_REGEX = /dob_\d+/
const GENDER_CHILD_REGEX = /gender_\d+/

/**
 * It takes an object of form data, and returns an array of objects with the child's dob and gender
 * @param formData - The form data object that contains all the form fields.
 * @returns An array of objects with the keys dob and gender.
 */
export function buildChildrenData(formData): { dob: string; gender: string }[] {
  return Object.values(
    Object.keys(formData).reduce((acc, key) => {
      const isDob = DOB_CHILD_REGEX.test(key)
      const isGender = GENDER_CHILD_REGEX.test(key)
      const index = key.split('_')[1]

      if (isDob) acc[index] = { dob: formData[key] }
      if (isGender) acc[index] = { ...acc[index], gender: formData[key] }

      return acc
    }, {})
  )
}

export function buildSpValue(valuesForm) {
  const childrenData = buildChildrenData(valuesForm)
  return buildSpValueToString(valuesForm, form => {
    const response = {
      zipcode: form?.zip?.location?.zipCode ?? '',
      censusUrgency: form?.censusUrgency ?? '',
      gender: form?.gender ?? '',
      dateOfBirth: form?.dob ?? '',
      firstName: form?.fname ?? '',
      emailAddress: form?.email ?? '',
      phoneIncluded: form?.phone ? 'phoneIncluded' : 'phoneNotIncluded',
      spouseIncluded: form?.dob_s ? 'spouseIncluded' : 'spouseNotIncluded'
    }
    if (form?.gender_s) {
      response['spouseGender'] = form?.gender_s
    }
    if (form?.dob_s) {
      response['spouseDob'] = form?.dob_s
    }
    response['childrenIncluded'] = childrenData.length
      ? 'childrenIncluded'
      : 'childrenNotIncluded'

    if (childrenData.length) {
      response['childrenCount'] = childrenData.length
    }
    if (childrenData.length > 0) {
      response['children'] = buildSpValueToString(childrenData)
    }

    return response
  })
}
